function fillAsaas3dsDeviceInfo(root) {
    const fields = {
        colorDepth: window.screen?.colorDepth ?? "",
        screenHeight: window.screen?.height ?? "",
        screenWidth: window.screen?.width ?? "",
        timeZoneOffset: new Date().getTimezoneOffset(),
        language: navigator.language ?? "",
        userAgent: navigator.userAgent ?? "",
    };

    Object.entries(fields).forEach(([key, value]) => {
        const input = root.querySelector(`[data-asaas-device-field="${key}"]`);

        if (!input) {
            return;
        }

        input.value = value;
    });
}

function bootstrapAsaas3dsDeviceInfo() {
    document.querySelectorAll("[data-asaas-3ds-device-info]").forEach((root) => {
        fillAsaas3dsDeviceInfo(root);
    });
}

document.addEventListener("DOMContentLoaded", bootstrapAsaas3dsDeviceInfo);
window.addEventListener("pageshow", bootstrapAsaas3dsDeviceInfo);
